import React, { useState, useEffect } from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { AnimatePresence } from "framer-motion";

import Home from "./Screens/Home/Home.jsx";
import Story from "./Screens/Story/Story.jsx";
import Contact from "./Screens/ContactUs/ContactUs.jsx";
import Menu from "./Screens/Menu/Menu.jsx";
import Gallery from "./Components/Gallery/Gallery.jsx";
import GiftCards from "./Screens/GiftCards/GiftCards.jsx";
import Catering from "./Screens/Catering/Catering.jsx";
import Locations from "./Screens/Locations/Locations.jsx";
import FoodMenu from "./Screens/FoodMenu/FoodMenu.jsx";
import DrinkMenu from "./Screens/DrinkMenu/DrinkMenu.jsx";
import PastryMenu from "./Screens/PastryMenu/PastryMenu.jsx";
import Navbar from "./Components/NavBar/Navbar";
import TakeAway from "./Screens/TakeAway/TakeAway";
import LoadingScreen from "./Components/Loading/Loading.jsx";

function AnimatedRoutes() {
  const location = useLocation();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {loading ? (
        <LoadingScreen />
      ) : (
        <>
          <Navbar />
          <AnimatePresence mode="wait">
            <Routes location={location} key={location.pathname}>
              <Route path="/" element={<Home />} />
              <Route path="/story" element={<Story />} />
              <Route path="/menu" element={<Menu />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/giftcards" element={<GiftCards />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/catering" element={<Catering />} />
              <Route path="/locations" element={<Locations />} />
              <Route path="/foodmenu" element={<FoodMenu />} />
              <Route path="/drinkmenu" element={<DrinkMenu />} />
              <Route path="/pastrymenu" element={<PastryMenu />} />
              <Route path="/takeaway" element={<TakeAway />} />
            </Routes>
          </AnimatePresence>
        </>
      )}
    </>
  );
}

export default function App() {
  return (
    <Router>
      <AnimatedRoutes />
    </Router>
  );
}
